module.exports = __webpack_public_path__ + "static/media/MONTH_MOBILE.11df31f4.png";